export const troubleshootingContent = `# Error Handling & Troubleshooting

**Common issues**

* **401/404 on entitlement** → Check \`publishableKey\` and \`appSlug\`.
* **Always logged out** → Ensure you passed a valid \`supabaseClient\`.
* **Checkout fails** → Verify Stripe test vs live keys and Price ID.
* **Paywall never shows** → Ensure \`autoShowPaywall=true\` and you're inside \`ProtectedRoute\`.

**User-friendly messages**

* Auth errors surface in modal.
* Payment errors show retry/alternative method actions.
* Entitlement fetch failure shows a "Try again" button.`;
